<template>
    <div class="form-group">
        <label class="form-check-label mb-1">{{ cardTitle }}</label>
        <TypeaheadInput
            :getData="getVendorList"
            :value="vendor"
            placeholder="Start Typing..."
            :character-limit="3"
            v-on:valueChanged="vendorChanged"
        ></TypeaheadInput>
        <div class="ms-3 mt-3 card card-body p-3" v-if="loadingVendorDetails">
            <p>
                <span class="shimmer-loading block-size-6"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-4"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-8"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-6"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-4"></span>
            </p>
        </div>
        <div class="mt-2 card p-2 d-flex flex-column" v-if="!loadingVendorDetails && vendorDetails.id">
            <h5 class="mb-2">{{ vendorDetails.name }}</h5>
            <section class="d-flex mb-1">
                <FormatName
                    :first-name="vendorDetails.contactFirstName"
                    :last-name="vendorDetails.contactLastName"
                ></FormatName>
            </section>
            <section class="d-flex mb-1">
                <span class="me-1">{{ vendorDetails.address.addressLine1 }},</span>
                <span class="me-1" v-if="vendorDetails.address.addressLine2">
                    {{ vendorDetails.address.addressLine2 }},
                </span>
                <span class="me-1">{{ vendorDetails.address.city }},</span>
                <span class="me-1">{{ vendorDetails.address.state }}</span>
                <span class="me-1">{{ formatZipCode(vendorDetails.address.zipCode) }}</span>
            </section>
            <section class="d-flex mb-1">
                <span v-if="!!vendorDetails.primaryPhone">
                    Phone:
                    <EmptyTextHandler :text="formatPhoneNumber(vendorDetails.primaryPhone.number)"></EmptyTextHandler>
                </span>
                <span v-else>
                    Phone:
                    <EmptyTextHandler :text="formatPhoneNumber(vendorDetails.primaryPhone)"></EmptyTextHandler>
                </span>
            </section>
            <section class="d-flex mb-1">
                <span>
                    Fax: <EmptyTextHandler :text="formatPhoneNumber(vendorDetails.faxNumber)"></EmptyTextHandler>
                </span>
            </section>
            <section class="d-flex" v-if="vendorDetails.email">
                <span> {{ vendorDetails.email }}</span>
            </section>
        </div>
    </div>
</template>

<script lang="ts" src="./PatientVendor.ts"></script>
